// Comparing teams on a Stats tile (Ben, 2026-11-01: "add a second team … in the same way I can add
// a 2/3/4/5 player", across leagues too). The pure half: who may join, and the colours. The
// gestures are team-merge.ts.

import type { TeamRef } from "../live/team.js";
import { MAX_COMPARE_PLAYERS } from "./drop-rules.js";

/** May `team` join a tile already showing `members`? Not the same team on the same season twice,
 *  and no more than a player comparison holds (five). */
export function teamJoinDecision(members: readonly TeamRef[], team: TeamRef): "join" | "duplicate" | "full" {
  if (members.some((m) => m.id === team.id && (m.season ?? null) === (team.season ?? null))) return "duplicate";
  if (members.length >= MAX_COMPARE_PLAYERS) return "full";
  return "join";
}

/** Everyone after a join: the tile's team(s), then the newcomer. */
export function joinedTeams(current: TeamRef, merged: readonly TeamRef[] | undefined, team: TeamRef): TeamRef[] {
  return [...(merged && merged.length ? merged : [current]), team];
}
